import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-paper-plane-sharp",
  "use": "icon-paper-plane-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-paper-plane-sharp\"><title>Paper Plane</title><path d=\"M496 16L15.88 208 195 289 448 64 223 317l81 179L496 16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol